/**
 * Adds a `data-platform` attribute (`android` | `ios` | `web`) to <html> once
 * on boot so CSS can target native Android specifically. Used to tweak
 * semi-transparent surfaces that render weirdly in the Android WebView
 * without a working `backdrop-filter`.
 */
export function tagPlatform() {
  if (typeof document === "undefined") return;
  let platform = "web";
  try {
    const cap = window.Capacitor;
    if (cap?.isNativePlatform?.()) {
      const p = cap.getPlatform?.();
      if (p === "android" || p === "ios") platform = p;
    }
  } catch { /* ignore */ }
  document.documentElement.setAttribute("data-platform", platform);
}
